<div class="confirm-modal ig-modal edit-event-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <h3 class="title">EDIT EVENT</h3>
    <!--    <div class="view-change-history" (click)="showChangeHistory()">View change history</div>-->

    <div class="edit-wrap flex justify-center" style="gap: 12px;">
        <ig-row [ngStyle]="{'width':aiGeneratedDescription.length?'50%':'100%'}" style="overflow:auto">
            <ig-col [xs]="12" [md]="12" class="edit-event-fields">
                <ig-row>
                    <ig-col [xs]="12">
                        <ig-field label="Event Title *" [(ngModel)]="event.name" [isRequired]="true" icon="stars"
                            [formControl]="createEventForm.get('name')">
                        </ig-field>
                    </ig-col>
                </ig-row>
                <ig-row>
                    <ig-col [xs]="12">
                        <ig-field label="Event Host *" [(ngModel)]="event.owner.name" [isRequired]="true" icon="person"
                            [formControl]="createEventForm.get('host')">
                        </ig-field>
                    </ig-col>
                </ig-row>
                <ig-row>
                    <ig-col [xs]="12">
                        <ig-field label="Location / Venue Name" icon="location_city"
                            [formControl]="createEventForm.get('venue')" [(ngModel)]="event.venue">
                        </ig-field>
                    </ig-col>
                </ig-row>
                <ig-row>
                    <ig-col [xs]="12">
                        <ig-address-input [label]="addressInputLabel"
                            label2="Start typing the physical address and select from a verified Google Maps address below"
                            matTooltip="please type and select an address from the dropdown" [(ngModel)]="event.address"
                            [formControl]="createEventForm.get('address')">
                        </ig-address-input>
                        <p *ngIf="!event.isOnlineEvent&&(!event.address?.lat||!event.address?.lng)" style="color:red;margin-bottom: 8px;font-size:14px;margin-top: -8px;text-align: left;
                        ">The address for this event may not be accurate, or it is not a recognized Google Maps
                            address. Please edit it and select from the dropdown; otherwise, the event will not be
                            displayed in Map View</p>
                        <div class="text-left">
                            <span *ngIf="isAllowOnlineEvents" class="m-r-3">
                                <mat-checkbox class="m-b-3" [(ngModel)]="event.isOnlineEvent"
                                    (change)="virtualEventChange()">Virtual Event
                                </mat-checkbox>
                                <mat-icon matTooltip="Virtual events don't have physical addresses">info</mat-icon>
                            </span>

                            <mat-checkbox class="m-b-3" [(ngModel)]="event.isHybridEvent"
                                (change)="hybridEventChange()">Hybrid Event</mat-checkbox>
                            <mat-icon matTooltip="Hybrid events are both virtual and in-person">info</mat-icon>
                        </div>
                    </ig-col>
                </ig-row>
                <ig-row>
                    <ig-col [xs]="12">
                        <ig-field #inputElement label="Event Organizer Email Address" [isRequired]="false" icon="mail"
                            [formControl]="createEventForm.get('organizerEmail')" [(ngModel)]="event.organizerEmail">
                        </ig-field>
                    </ig-col>
                </ig-row>
                <ig-row>
                    <ig-col [xs]="12">
                        <ig-field label="Event URL for more information (if applicable)" [(ngModel)]="event.eventLink"
                            icon="link" [formControl]="createEventForm.get('eventLink')">
                        </ig-field>
                    </ig-col>
                </ig-row>
                <ig-row>
                    <ig-col [xs]="12">
                        <ig-field label="Event Host Website URL" icon="link"
                            [formControl]="createEventForm.get('hostLink')" [(ngModel)]="event.hostLink">
                        </ig-field>
                    </ig-col>
                </ig-row>
                <ig-row *ngIf="toggles.eventTicketUrl">
                    <ig-col [xs]="12" class="text-left">
                        <ig-field
                            *ngIf="isNormalTicketUri||(!event.ticketUri&&(!event.ticketInfo||!event.ticketInfo.length))"
                            label="Get Tickets URL (if applicable)" icon="receipt"
                            [formControl]="createEventForm.get('ticketUri')" [(ngModel)]="event.ticketUri">
                        </ig-field>

                        <ng-container *ngIf="!isNormalTicketUri&&event.ticketInfo&&event.ticketInfo.length">
                            <ig-field label="Get Tickets URL (if applicable)" icon="receipt"
                                [formControl]="createEventForm.get('ticketUri')" [(ngModel)]="event.ticketInfo[0].link">
                            </ig-field>

                            <ig-field *ngIf="event.ticketInfo&&event.ticketInfo.length>1"
                                label="Additional Tickets URL (if applicable)" icon="receipt"
                                [formControl]="createEventForm.get('ticketUri2')"
                                [(ngModel)]="event.ticketInfo[1].link">
                            </ig-field>

                        </ng-container>
                        <mat-checkbox class="m-b-3" [(ngModel)]="event.isHideTicketUrl">Hide Ticket URL
                        </mat-checkbox>
                    </ig-col>
                </ig-row>
                <ig-row>
                    <ig-col [xs]="12">
                        <ng-container *ngIf="event.description && !isEditDescription">
                            <div class="edit-item-title">
                                <span>Description</span>
                            </div>

                        </ng-container>
                        <div class="text-area" [class.no-height]="!isEditDescription">
                            <textarea id="description-editor"></textarea>
                        </div>

                        <div style="text-align:left">
                            <a (click)="generateDescription()" style="position:relative;"
                                [ngStyle]="{'top': isDescriptionNeedShowMore ? '0' : '0px'}">
                                <span *ngIf="!aiGeneratedDescription.length" style="font-size:14px;cursor:pointer"
                                    [ngStyle]="{'text-decoration':isGeneratingDescription ? 'none' : 'underline'}"
                                    matTooltip="Using AI to generate an introduction for this event">
                                    {{isGeneratingDescription ? 'Generating description...' : 'Try our AI Content
                                    Assistant'}}
                                    <img *ngIf="!isGeneratingDescription&&!aiGeneratedDescription.length"
                                        src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="" width="20">
                                </span>
                                <span *ngIf="aiGeneratedDescription.length">Description generated, please select
                                    one from the right side.</span>
                                <mat-icon *ngIf="isGeneratingDescription" matTooltip="Generating..." class="ig-spin"
                                    style="font-size:16px;width:16px;height:16px">autorenew</mat-icon>
                                <mat-icon *ngIf="aiGeneratedDescription.length&&!isGeneratingDescription"
                                    matTooltip="Generate again" (click)="generateDescription()"
                                    style="font-size:16px;width:16px;height:16px">autorenew</mat-icon>
                            </a>
                        </div>
                    </ig-col>
                </ig-row>
                <div class="flex" *ngFor="let timeRange of event.eventTimes; let i = index">
                    <div style="flex: 11">
                        <ig-datetime-input #dateTimeInput [frequency]="'custom'" [startDate]="timeRange.startTime"
                            [endDate]="timeRange.endTime" [allowNoTime]="event.isNoTime" [timezone]="event.timezone"
                            [timeFormatter]="event.timezoneFormatter" [disabled]="isLoadingTimezone"
                            [isManualCreated]="event.isManuallyCreated"
                            (change)="setEventTime($event, timeRange)"></ig-datetime-input>
                    </div>
                    <!--                    <ig-col [xs]="1" matTooltip="change time zone" class="timezone"-->
                    <!--                            (click)="showTimezoneCitySelector=true">-->
                    <!--                        <span *ngIf="!isLoadingTimezone">{{event.timezone}}</span>-->
                    <!--                        <mat-spinner *ngIf="isLoadingTimezone" [diameter]="22" [strokeWidth]="3"></mat-spinner>-->
                    <!--                    </ig-col>-->
                    <div style="flex: 1" class="time-plus" *ngIf="frequency === 'custom' || frequency === 'event'">
                        <ig-button *ngIf="!i" (trigger)="addTimeRange()" matTooltip="Add more dates">+
                        </ig-button>
                        <ig-button *ngIf="i" (trigger)="removeTimeRange(i)" color="cancel"
                            matTooltip="Remove this date">-
                        </ig-button>
                    </div>
                </div>
                <div class="flex">
                    <div style="flex: 1; margin-right: 12px;position: relative;">
                        <mat-icon matTooltip="You can only change the timezone of manually created events"
                            class="not-change-tip">info
                        </mat-icon>
                        <ig-city-selector [disabled]="!event.isManuallyCreated"
                            [label]="'TimeZone (' + event.timezone + ')'" [(ngModel)]="timezoneAddress"
                            [isRequired]="false" placeholder="Enter a city to change timezone" type="text"
                            (ngModelChange)="citySelected()"
                            [formControl]="createEventForm.get('timezone')"></ig-city-selector>
                    </div>

                    <div style="flex: 1">
                        <ig-select [(ngModel)]="frequencyItems" label="Frequency" (onOpen)="setFrequencyDropdown()"
                            (itemSelected)="frequencySourceChange($event)">
                        </ig-select>
                        <div *ngIf="
                totalTimes && frequency !== 'custom' && frequency !== 'event'
              " style="
                color: #99abb4;
                margin-bottom: 22px;
                text-align: left;
                font-size: 14px;
              ">
                            <span><b>{{ totalTimes.split("Dates")[0] }} Dates</b></span><span
                                style="margin-left: 16px">{{
                                totalTimes.split("Dates")[1]
                                }}</span>
                        </div>
                    </div>
                </div>
            </ig-col>
            <ig-col [xs]="12" [md]="12">
                <mat-radio-group class="edit-event-radio-group" (ngModelChange)="imageWayChange()"
                    [(ngModel)]="isUploadImage">
                    <div class="relative flex flex-col items-center">
                        <mat-radio-button [value]="true"> Upload Image</mat-radio-button>

                        <img #img *ngIf="selectedImageData" [src]="resizeImageTemp||selectedImageData" width="60%"
                            alt="" />

                        <div #upload *ngIf="!selectedImageData" class="img-upload"
                            (click)="isUploadImage && imageSelector.click()">
                            <mat-icon [class.pointer]="isUploadImage">photo</mat-icon>
                            <p>Select Your Image</p>
                        </div>

                        <div #mask *ngIf="selectedImageData" class="img-mask"
                            (click)="isUploadImage && imageSelector.click()">
                            Change Image
                        </div>
                        <input type="file" class="invisible" accept="image/png,image/gif,image/jpeg" #imageSelector
                            (change)="onImageChange($event)" />
                    </div>
                    <div imageor (click)="refreshImage()">
                        <span>OR</span>
                        <ig-spinner *ngIf="isRefreshingImage"></ig-spinner>
                    </div>

                    <div>
                        <mat-radio-button [value]="false"> Image Link</mat-radio-button>

                        <ig-mat-field label="Image Link" [(ngModel)]="imageLink" [disabled]="isUploadImage"
                            (onModelChange)="isImageChanged = true" [formControl]="createEventForm.get('imageLink')">
                        </ig-mat-field>

                        <div *ngIf="!isUploadImage && (resizeImageTemp || imageLink)" class="resize-image-preview">
                            <div>Preview</div>
                            <ig-image [imageUrl]="(resizeImageTemp || imageLink)"></ig-image>
                        </div>
                        <ig-image-resize  [imageToResize]="isUploadImage ? resizeImageTemp : imageLink"
                            (onImageResized)="imageResized($event)"></ig-image-resize>

                        <mat-checkbox *ngIf="isImageChanged" [(ngModel)]="hasCopyrights">Please note that any images
                            uploaded or used in
                            this software must either be royalty-free or owned by the client. By uploading or using an
                            image, you
                            acknowledge that you have the necessary rights to use it and that you will be solely
                            responsible for any
                            copyright infringement or other legal issues that may arise from the use of the image. We
                            strongly advise our
                            users to exercise due diligence and ensure that they have the necessary rights to use any
                            images uploaded or
                            used in this software.
                        </mat-checkbox>
                    </div>
                </mat-radio-group>
            </ig-col>
        </ig-row>

        <div *ngIf="aiGeneratedDescription.length" style="width:50%;text-align:left;position:relative">
            <p style="font-weight:bold">AI generated descriptions:</p>

            <div *ngIf="isRegeneratingDescription" class="absolute full-width full-height top-0"
                style="opacity:0.7;background:white">
            </div>
            <div *ngIf="isRegeneratingDescription"
                class="absolute full-width full-height flex justify-center items-center top-0">
                <mat-icon class="ig-spin"
                    style="font-size: 40px;width:40px;height:40px;color:deepskyblue;cursor:default">autorenew</mat-icon>
            </div>

            <div *ngFor="let des of aiGeneratedDescription;let i = index" (click)="selectDescription(des)"
                [ngStyle]="{'outline':event.description === des ? '2px solid deepskyblue' : '2px dashed #ccc', 'cursor': isRegeneratingDescription? 'default' : 'pointer'}"
                style="margin:16px 2px 0 2px;border-radius:6px;height:15vh;overflow:auto;padding:8px 12px;cursor:pointer">
                <p style="margin-bottom:4px;font-weight:bold">Version {{i+1}}:</p>
                {{des}}
            </div>
        </div>
    </div>

    <div class="action-btns">
        <ig-button class="btn-primary" #confirmButton color="primary" size="md"
            [disabled]="isFormInvalid || isLoadingTimezone" [isAsync]="true" (trigger)="confirm($event)">
            Save
        </ig-button>
        <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
            Cancel
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.event.modal/edit.event.modal.component.html